import "core-js/modules/es6.object.assign";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
import { recursiveMenu, deepcopy } from '@/libs/util';
import { login_success_permission } from '@/api/auth';
export default {
  name: "addAccoutAuth",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      currSelectList: {},
      //当前所选的列
      apilist: [],
      //所属于的接口
      indeterminate: true,
      checkAll: false,
      currCode: null,
      checkAllGroup: [],
      //选中的项
      currInterFace: [],
      //当前选中的接口列表
      showInterFace: false,
      personMenuData: [],
      reqBase: {
        page: 1,
        page_size: 100
      },
      spinShow: false,
      interConfit: [],
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      formModel: {
        admin_name: null,
        shop_name: null,
        menu_config: []
      },
      formRules: {}
    };
  },
  props: {
    _vm: {},
    edit: {},
    setData: {},
    personMenu: {},
    admin_id: {}
  },
  components: {},
  computed: {},
  methods: {
    handleCheckAll: function handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }

      this.indeterminate = false;

      if (this.checkAll) {
        var arr = [];

        for (var i in this.apilist) {
          var list = this.apilist[i];
          arr.push(list.api_code);
        }

        this.checkAllGroup = arr;
      } else {
        this.checkAllGroup = [];
      }
    },
    checkAllGroupChange: function checkAllGroupChange(data) {
      //  alert(123);
      if (data.length === this.apilist.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    showModal: function showModal(b) {
      this.showInterFace = b;
    },
    initInterFace: function initInterFace() {},
    //接口取消
    interfaceCancel: function interfaceCancel() {
      //this.currSelectList = {};//当前所选的列
      this.apilist = []; //所属于的接口

      this.indeterminate = true;
      this.checkAll = false;
      this.checkAllGroup = []; //选中的项

      this.showModal(false);
    },
    //接口保存
    interfaceOk: function interfaceOk() {
      this.currSelectList[this.currCode] = deepcopy(this.checkAllGroup); //当前所选

      this.showModal(false);
    },
    visibleChange: function visibleChange(b) {
      if (b) {
        this.initInterFace();
      } else {
        this.showModal(false);
      }
    },
    renderContent: function renderContent(h, _ref) {
      var root = _ref.root,
          node = _ref.node,
          data = _ref.data;
      var arr = [];

      if (data.category === 1) {// arr.push(h('Button', {
        //   props: Object.assign({}, this.buttonProps, {}),
        //   style: {
        //     marginRight: '8px'
        //   },
        //   on: {
        //     click: () => {
        //       this.selectInterFace(data)
        //     }
        //   }
        // }, '接口配置'));
      }

      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: 'ios-paper-outline'
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', data.title)]), h('span', {
        style: {
          display: 'inline-block',
          float: 'right',
          marginRight: '32px'
        }
      }, arr)]);
    },

    /**
     * 打开选择接口配置
     * @param data
     */
    selectInterFace: function selectInterFace(data) {
      //alert(123);
      console.log("aaa", this.currSelectList);
      console.log("bbb", this.currCode); // return;
      //debugger

      this.checkAllGroup.splice(0); //清空选择项

      this.apilist.splice(0);
      this.currCode = data.code; //console.log("this.currCode111",this.currCode);

      if (!this.currSelectList.hasOwnProperty(this.currCode)) {
        this.currSelectList[this.currCode] = deepcopy(data.api_codes); //当前所选

        for (var i = 0; i < data.apilist.length; i++) {
          //console.log(data.apilist[i])
          var list = data.apilist[i];

          if (list.checked === 1) {
            //console.log("aa",list.res_name)
            this.checkAllGroup.push(list.api_code);
          }
        }
      } else {
        var _this$checkAllGroup;

        (_this$checkAllGroup = this.checkAllGroup).push.apply(_this$checkAllGroup, _toConsumableArray(this.currSelectList[this.currCode])); // for(let i=0;i<data.apilist.length;i++){
        //   //console.log(data.apilist[i])
        //   let list=data.apilist[i]
        //   if(list.checked===1){
        //     //console.log("aa",list.res_name)
        //     this.checkAllGroup.push(list.api_code)
        //   }
        // }

      }

      this.apilist = deepcopy(data.apilist); //所选中的项
      // this.checkAllGroup = this.currSelectList[this.currCode];

      this.checkAll = this.checkAllGroup.length === this.apilist.length;
      this.showModal(true);
    },
    //选中菜单权限的change
    checkChange: function checkChange(checkData) {
      return; // console.log(event);
      // return
      // alert(13); 

      console.log("aa", checkData);
      console.log("bb", this.interConfit);
      console.log("ccc", this.currCode);
      var arr = [];

      for (var i in checkData) {
        var list = checkData[i];

        if (list.nodeKey !== 0) {
          arr.push(list.id); //需要改接口状态

          for (var ii in this.interConfit) {
            //console.log("aaa", this.interConfit[ii].menu_name)
            if (this.interConfit[ii].category == 1 && this.interConfit[ii].code == list.code) {
              //  console.log("bb",this.interConfit[ii])
              for (var iii in this.interConfit[ii].apilist) {
                this.interConfit[ii].apilist[iii].checked = 1;
              }
            } else if (this.interConfit[ii].category == 0) {
              //console.log("asdf3",this.interConfit[ii].menu_name);
              for (var _iii in this.interConfit[ii].children) {
                //  console.log("asdf2",this.interConfit[ii].children[iii].menu_name)
                if (this.interConfit[ii].children[_iii].code == list.code) {
                  //   console.log("asdf",list.menu_name);
                  for (var iiii in this.interConfit[ii].children[_iii].apilist) {
                    // console.log(this.interConfit[ii].children_menu[iii].apilist[iiii].res_name)
                    this.interConfit[ii].children[_iii].apilist[iiii].checked = 1;
                  }
                } //  this.interConfit[ii].apilist[iii].checked=1

              }
            }
          }
        }
      }

      console.log(this.interConfit);
      this.$set(this.formModel, 'menu_config', arr);
    },
    initMenu: function initMenu() {
      var _this = this;

      //console.log("aaaaaaa")
      //console.log(this.setData.uid)
      var vm = this;
      this.spinShow = true; // this._vm.$store.dispatch("auth/handlelogin_success_permission", {uid: this.setData.uid}).then(res => {

      login_success_permission({
        uid: this.setData.uid
      }).then(function (res) {
        //console.log("bbb",res)
        if (res.result === 0) {
          _this.interConfit = recursiveMenu(res.body); //console.log(this.interConfit)

          _this.spinShow = false;

          if (res.result === 0) {
            _this.interConfit = recursiveMenu(res.body);
            console.log(_this.interConfit);
          } else {}
        } else {}
      }).catch(function (err) {// this.tableLoading=false;
      }); // console.log("bbbbb")
      //})
    }
  },
  mounted: function mounted() {},
  created: function created() {
    if (this.edit) {
      // debugger
      Object.assign(this.formModel, this.setData); //this.$set(this.formModel, 'menu_config', arr)
    }

    if (this.personMenu) {
      this.personMenuData.push(this.personMenu);
      this.$set(this.formModel, "parent_id", this.personMenu.personId);
    }

    this.initMenu();
  }
};